import React, { memo } from "react";
import { androidUrl, appleUrl, AppStoreButton, Footer, FooterIconSmall, PlayStoreButton, useScreenWidth } from "../Landing";
import '../Landing.css';

const CSAEStandards = () => {
    const { isMobile } = useScreenWidth();

    return (
        <div style={{
            background: 'white',
            overflow: 'hidden',
            overflowY: 'scroll',
            height: '100vh',
            width: '100vw',
        }}>
            <link href="https://fonts.googleapis.com/css2?family=Playwrite+IT+Moderna:wght@100..400&family=Satisfy&display=swap" rel="stylesheet"/>
            <div style={{
                position: 'relative',
                display:'flex',
                flexDirection: isMobile ? 'column' : 'row',
                justifyContent: isMobile ? 'center' : 'space-between',
                alignItems: 'center',
                marginTop: 50,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 100,
                padding: 12,
                paddingTop: 8,
                paddingLeft: 40,
                paddingRight: 40,
                borderRadius: 80,
                backgroundColor: "white",
            }}>
                <FooterIconSmall/>
                <div
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    justifyContent: isMobile ? 'center' : 'space-between',
                    alignItems: 'center',
                    gap: 20,
                    marginTop: isMobile ? 20 : 0,
                }}>
                    <AppStoreButton size={isMobile ? 'small' : 'medium'} shadow={isMobile ? false : true}  color='black' onClick={() => window.open(appleUrl, '_blank')} />
                    <PlayStoreButton size={isMobile ? 'small' : 'medium'} shadow={isMobile ? false : true}  color='black' onClick={() => window.open(androidUrl, '_blank')} />
                </div>
            </div>
            
            <br/>

            <div style={{
                background: 'white',
                overflow: 'auto',
                width: '100%',
                padding: isMobile ? '20px' : '40px',
                maxWidth: '800px',
                margin: '20px auto',
                borderRadius: '8px',
                fontFamily: 'sans-serif',
                color: '#333',
                lineHeight: 1.6,
            }}>
                <h2 style={{
                    fontSize: isMobile ? '24px' : '32px',
                    marginBottom: '20px',
                    color: '#2c3e50',
                    textAlign: 'center',
                }}>PeaColony Standards Against Child Sexual Abuse and Exploitation (CSAE)</h2>

                <p>PeaColony has a zero-tolerance policy regarding child sexual abuse and exploitation (CSAE). We are committed to creating a safe and positive environment for all our users, and the protection of children is our highest priority.</p>

                <h3 style={{
                    fontSize: isMobile ? '18px' : '22px',
                    marginTop: '25px',
                    marginBottom: '10px',
                    color: '#2c3e50',
                }}>Important Note Regarding Current Application Version:</h3>
                <p>Please be aware that the current version of the PeaColony application is <strong>designed for users who are 18 years of age or older.</strong></p>

                <h3 style={{
                    fontSize: isMobile ? '18px' : '22px',
                    marginTop: '25px',
                    marginBottom: '10px',
                    color: '#2c3e50',
                }}>Prohibited Content and Behavior:</h3>
                <ul>
                    <li>Any content that depicts, encourages, promotes, or provides instructions on the abuse, victimization, and exploitation of children. This includes, but is not limited to, child sexual abuse material (CSAM), the sexualization of minors, and content that appears to groom, endanger, or otherwise exploit children.</li>
                    <li>Any attempts to solicit, share, or create content related to CSAE.</li>
                    <li>Any behavior that could be interpreted as grooming, or any interaction with a minor that is sexually suggestive, inappropriate, or exploitative.</li>
                </ul>

                <h3 style={{
                    fontSize: isMobile ? '18px' : '22px',
                    marginTop: '25px',
                    marginBottom: '10px',
                    color: '#2c3e50',
                }}>Reporting Mechanisms:</h3>
                <p>PeaColony provides multiple avenues for users to report any suspected instances of CSAE or inappropriate behavior targeting children:</p>
                <ol>
                    <li><strong>In-App Reporting:</strong> Users can directly report any content or behavior they deem suspicious or harmful through the reporting features available within the PeaColony app. This allows for immediate flagging and review by our moderation team.</li>
                    <li><strong>Email Reporting:</strong> Users can also report any concerns related to CSAE or inappropriate behavior by sending an email to our dedicated support address: <a href="mailto:support@peacolony.com" style={{ color: '#3498db', textDecoration: 'underline' }}>support@peacolony.com</a>. Please provide as much detail as possible, including usernames, specific content, and timestamps if available, to aid in our investigation.</li>
                </ol>

                <h3 style={{
                    fontSize: isMobile ? '18px' : '22px',
                    marginTop: '25px',
                    marginBottom: '10px',
                    color: '#2c3e50',
                }}>Reporting Users Under 18:</h3>
                <p>Given that our current application is designed for users aged 18 and above, we strongly encourage you to <strong>report any user you believe to be under the age of 18 through the in-app reporting features or via email to <a href="mailto:support@peacolony.com" style={{ color: '#3498db', textDecoration: 'underline' }}>support@peacolony.com</a></strong>. Reporting underage users helps us to take appropriate action, which is crucial in reducing the chance and possibility of harm to children.</p>

                <h3 style={{
                    fontSize: isMobile ? '18px' : '22px',
                    marginTop: '25px',
                    marginBottom: '10px',
                    color: '#2c3e50',
                }}>Our Commitment to Action:</h3>
                <p>Upon receiving a report of suspected CSAE, related inappropriate behavior, or a user potentially under the age of 18, PeaColony will take immediate and decisive action, which may include:</p>
                <ul>
                    <li><strong>Prompt investigation</strong> of the reported content and user activity.</li>
                    <li><strong>Immediate removal</strong> of any content that violates these standards.</li>
                    <li><strong>Permanent suspension</strong> of user accounts involved in such activities.</li>
                    <li><strong>Removal of accounts</strong> belonging to users identified as being under 18.</li>
                    <li><strong>Cooperation with law enforcement</strong> and relevant authorities, including reporting illegal content as required by law.</li>
                    <li><strong>Utilizing available technologies and partnerships</strong> to identify and remove CSAE.</li>
                </ul>

                <h3 style={{
                    fontSize: isMobile ? '18px' : '22px',
                    marginTop: '25px',
                    marginBottom: '10px',
                    color: '#2c3e50',
                }}>User Responsibility:</h3>
                <p>We rely on our community to help us maintain a safe environment. If you encounter any content or behavior that you believe may violate these standards or endanger a child, or if you identify a user who appears to be under the age of 18, please report it immediately through the in-app reporting features or via email to <a href="mailto:support@peacolony.com" style={{ color: '#3498db', textDecoration: 'underline' }}>support@peacolony.com</a>. Your vigilance is crucial in protecting vulnerable individuals.</p>

                <p>By using PeaColony, you agree to adhere to these standards and to contribute to a community that prioritizes the safety and well-being of all its members, especially children. We are committed to continuously reviewing and updating these standards to ensure the highest level of protection.</p>
            </div>
            <Footer/>
            <div style={{position: 'relative', height: 150, width: '100vw' }}></div>
        </div>
    );
};

export default memo(CSAEStandards);